import React from "react";
import Box from "../elements/Box";

export default function CardLayout ({ className, children, ...rest }) {
    return <Box className={`mc-card ${ className ? className : "" }`} {...rest}> { children }</Box>
}